import {capitalize} from "vue";
import {copyToClipboard, Notify} from "quasar";

function colorizeWords(words, split = null, capitalizeWords = false) {
    const colors = [
        '#ff3922',
        '#ff3922',
        '#ff3922'

        //'#cc1f1f',
        //'#48b944',
        //'#2c2cf1'
    ];

    if (words?.indexOf(' ') >= 0) {
        words = words.replaceAll(/\s{2,}/g, ' ').split(' ');
    } else if (typeof words === 'string') {
        words = words.trim().split(/(?=[A-Z])/).map(el => el.trim());
    }

    if (!Array.isArray(words)) {
        return words;
    }

    if (capitalizeWords) {
        words = words.map(item => capitalize(item.toLowerCase()));
    }

    return words
        .map((item, index) => {
            if (colors.hasOwnProperty(index)) {
                return `<span style="color:${colors[index]};">${item}</span>`;
            }

            let fallBackIndex = index % colors.length;
            return `<span style="color:${colors[fallBackIndex]};">${item}</span>`;
        })
        .join(split ? split : '');
}

function url(path = null, subdomain = null) {
    const appDomain = process.env.MIX_APP_DOMAIN;
    return `https://${subdomain ? subdomain + '.' : ''}${appDomain}/${path ?? ''}`;
}

function copyTextToClipboard(text) {
    copyToClipboard(text)
        .then(() => {
            Notify.create({
                position: "top",
                type: 'positive',
                message: 'Copied to your clipboard'
            });
        })
        .catch(() => {
            Notify.create({
                position: "top",
                type: 'negative',
                message: 'Error while copy link to your clipboard'
            });
        });
}

String.prototype.truncate = function (maxLength = 100) {
    if (this.length <= maxLength) {
        return this;
    }

    return this.substring(0, maxLength) + '...';
}

function pluralize (number, string1, string2 = null) {
    return number === 1 ? string1 : (string2 ? string2 : string1 + 's')
}

function daysToMonths(days){
    const years = Math.floor(days / 365);
    const months = Math.floor((days - (years * 365)) / 30);
    const d = days - (years * 365) - (months * 30);

    let parts = [];

    if(years > 0){
        parts.push(`${years} ${pluralize(years, 'year')}`);
    }

    if (months > 0) {
        parts.push(`${months} ${pluralize(months, 'month')}`);
    }

    if (d > 0){
        parts.push(`${d} ${pluralize(d, 'day')}`);
    }

    return parts.join(', ');
}

export {
    colorizeWords,
    url,
    copyTextToClipboard,
    pluralize,
    daysToMonths,
};
